import { apiRequest } from "../util/apiUtils";

export const pageList = async (params) => {
  try {
    const res = await apiRequest("get", `page/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const pageAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `page/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const pageDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `page/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const pageStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `page/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
